import createIcon from "./createIcon";

/** 大纲 Agent 发送 */
export const OutlineAgentSendIcon = createIcon("OutlineAgentSend", (props) => {
  return (
    <svg {...props} viewBox="0 0 30 30">
      <rect
        x="0"
        y="0"
        width="30"
        height="30"
        rx="6"
        fill={props.color}
        fillOpacity="1"
      />
      <path
        d="M15.00001,24C15.5863523,24,16.001304599999997,23.588202,16.001304599999997,22.997443C16.001304599999997,22.997443,16.001304599999997,11.941555000000001,16.001304599999997,11.941555000000001C16.001304599999997,11.941555000000001,15.929141999999999,10.0078995,15.929141999999999,10.0078995C15.929141999999999,10.0078995,18.265531,12.5950561,18.265531,12.5950561C18.265531,12.5950561,20.322229,14.6182318,20.322229,14.6182318C20.502558,14.7972727,20.755142,14.9136519,21.034822,14.9136519C21.585048,14.9136519,21.999999000000003,14.5018525,21.999999000000003,13.9378715C21.999999000000003,13.678263699999999,21.900751,13.4365621,21.684295,13.2217088C21.684295,13.2217088,15.7397089,7.3133232,15.7397089,7.3133232C15.5412545,7.10742542,15.270627000000001,7,15.00001,7C14.720371199999999,7,14.449754200000001,7.10742542,14.2512994,7.3133232C14.2512994,7.3133232,8.31572202,13.2217088,8.31572202,13.2217088C8.099226996,13.4365621,8,13.678263699999999,8,13.9378715C8,14.5018525,8.40592873,14.9136519,8.95618761,14.9136519C9.2448469,14.9136519,9.4974208,14.7972727,9.6778426,14.6182318C9.6778426,14.6182318,11.7255192,12.5950561,11.7255192,12.5950561C11.7255192,12.5950561,14.070888,9.9989564,14.070888,9.9989564C14.070888,9.9989564,13.9897037,11.941555000000001,13.9897037,11.941555000000001C13.9897037,11.941555000000001,13.9897037,22.997443,13.9897037,22.997443C13.9897037,23.588202,14.4046459,24,15.00001,24C15.00001,24,15.00001,24,15.00001,24Z"
        fill="#FFFFFF"
        fillOpacity="1"
      />
    </svg>
  );
});
